<template>
  <div class="sidebar-content">
    <div class="logo as-flex main-center cross-center">
      <img src="../assets/images/sidebar-logo.png" width="90%">
    </div>
    <div class="search as-flex main-center cross-center">
      <searchInput></searchInput>
    </div>
    <div class="navigator">
      <navigator></navigator>
    </div>
  </div>
</template>

<script>
import searchInput from "./sideBar/searchInput";
import navigator from "./sideBar/navigator";
export default {
  name: "sideBar",
  props: {},
  components: {
    searchInput: searchInput,
    navigator: navigator
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  watch: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.sidebar-content {
  width: 100%;
  height: 100%;
  padding: 0 0px;
  .logo {
    width: 100%;
    // height: 100px;
  }
  .search {
    width: 100%;
    height: 100px;
    margin: 20px 0;
    position: relative;
  }
  .navigator {
    width: 100%;
    padding: 20px 0;
  }
}
</style>
